import { render, staticRenderFns } from "./tenderResearch.vue?vue&type=template&id=6a963f6a&scoped=true&"
import script from "./tenderResearch.vue?vue&type=script&lang=js&"
export * from "./tenderResearch.vue?vue&type=script&lang=js&"
import style0 from "./tenderResearch.vue?vue&type=style&index=0&id=6a963f6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a963f6a",
  null
  
)

export default component.exports